export const COMPONENT_NAME = "kyb-basic-information";
